<template>
  <div class="p_trans" v-for="(item, index) in data_list" :key="index">
    <h2 class="activeR">
      <div class="club_info">
        <span>俱乐部：{{ item.club_name }}</span>
        <span>赛事：{{ item.sclass_name }}</span>
      </div>
    </h2>
    <dl class="hder">
      <dd style="width: 100px"><b>国家队</b></dd>
      <dd style="width: 200px"><b>球员</b></dd>
      <dd style="width: 100px"><b>号码</b></dd>
      <dd style="width: 100px"><b>位置</b></dd>
    </dl>
    <!-- 内容区 -->
    <div class="cen_box">
      <div
        class="cenT_b"
        v-for="(item2, index2) in item.data_list"
        :key="index2"
      >
        <dl class="cenT">
          <dd style="width: 100px" class="dd_f">{{ item2.team_name }}</dd>
          <dd style="width: 200px" class="dd_f fw">
            <router-link
              target="_blank"
              :to="`/soccer/players/${item2.player_id}`"
            >
              {{ item2.player_name }}
            </router-link>
          </dd>
          <dd style="width: 100px" class="dd_f">{{ item2.number }}</dd>
          <dd style="width: 100px" class="dd_f">{{ item2.place }}</dd>
        </dl>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { getCurrentInstance, ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "PlayerEqClub",
  props: {
    match_obj: {
      type: Object,
      required: true,
    },
    schedule_ids: {
      type: String,
    },
  },
  setup(props) {
    let { proxy: _this } = getCurrentInstance();
    let router = useRouter();
    let schedule_id =
      router.currentRoute.value.params.schedule_id || props.schedule_ids;
    console.log(schedule_id);
    let data_list = ref();
    let get_data_list = async () => {
      let { data: res } = await _this.$http.get(
        `soccer/match/${schedule_id}/player_eq_club`
      );
      data_list.value = res.data;
    };
    get_data_list();
    console.log(data_list);
    return {
      data_list,
    };
  },
};
</script>

<style scoped>
.club_info {
  width: 500px;
  display: flex;
  justify-content: space-between;
}
</style>
